import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class HealthUserAgreement extends Component {

    render() {
        const data = Data.healthUserAgreement;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/healthChina/healthUserAgreement.js